import moment from 'moment';
import Utils from './Utils';

const EMAIL_LAYOUT_TYPE_BOOKING = 'booking';

const PREVIEW_FILM_TITLES = {
    fr: 'Le Fabuleux Destin d\'Amélie Poulain',
    en: 'Amélie',
    de: 'Die fabelhafte Welt der Amélie',
};

const PREVIEW_PLACES = {
    fr: 'Cinéma Exemple - Salle 1',
    en: 'Example Cinema - Hall 1',
    de: 'Beispielkino - Saal 1',
};

/** Eshop booking-summary copy (from eshop locale / BSTranslator). */
const COPY = {
    fr: {
        heading: 'Nous vous remercions d\'avoir utilisé notre billetterie pour modifier vos réservations.',
        opening_named: '%s, vos réservations ont bien été modifiées.',
        next_bookings: 'Vos prochaines réservations',
        no_bookings: 'Il n\'y a actuellement aucune réservation sur ce billet.',
        changes_title: 'Aperçu des dernières modifications',
        change_booked: 'Réservation confirmée pour %s',
        disclaimer: 'Ce résumé, qui peut être %stéléchargé ici%s, ne permet pas l\'accès aux événements réservés.',
        qr_hint: 'L\'accès nécessite la présentation du code QR présent sur le billet. En cas de perte, une copie peut être obtenue en suivant %sce lien%s.',
        date_col: 'Date',
        booking_col: 'Réservation',
        place_col: 'Lieu',
        description_col: 'Description',
        sample_seat: 'Rang A - Siège 12',
    },
    en: {
        heading: 'Thank you for using our ticketing system to modify your bookings.',
        opening_named: '%s, your bookings have been successfully updated.',
        next_bookings: 'Your upcoming bookings',
        no_bookings: 'There are currently no bookings on this ticket.',
        changes_title: 'Overview of recent changes',
        change_booked: 'Booking confirmed for %s',
        disclaimer: 'This summary, which can be %sdownloaded here%s, does not grant access to reserved events.',
        qr_hint: 'Access requires presenting the QR code on the ticket. If lost, a copy can be obtained by following %sthis link%s.',
        date_col: 'Date',
        booking_col: 'Booking',
        place_col: 'Place',
        description_col: 'Description',
        sample_seat: 'Row A - Seat 12',
    },
    de: {
        heading: 'Wir danken Ihnen, dass Sie unser Ticketsystem zur Änderung Ihrer Reservierungen genutzt haben.',
        opening_named: '%s, Ihre Reservierungen wurden erfolgreich aktualisiert.',
        next_bookings: 'Ihre nächsten Reservierungen',
        no_bookings: 'Auf diesem Ticket gibt es derzeit keine Reservierungen.',
        changes_title: 'Übersicht der letzten Änderungen',
        change_booked: 'Reservierung bestätigt für %s',
        disclaimer: 'Diese Zusammenfassung, die %shier heruntergeladen%s werden kann, gewährt keinen Zugang zu reservierten Veranstaltungen.',
        qr_hint: 'Der Zugang erfordert die Vorlage des QR-Codes auf dem Ticket. Bei Verlust kann eine Kopie über %sdiesen Link%s bezogen werden.',
        date_col: 'Datum',
        booking_col: 'Reservierung',
        place_col: 'Ort',
        description_col: 'Beschreibung',
        sample_seat: 'Reihe A - Platz 12',
    },
};

const PREVIEW_CONTACT_BY_LANG = {
    fr: { firstname: 'Jean', lastname: 'Dupont', email: 'exemple@example.com' },
    en: { firstname: 'John', lastname: 'Smith', email: 'example@example.com' },
    de: { firstname: 'Hans', lastname: 'Müller', email: 'beispiel@example.com' },
};

function get_preview_sample_contact(lang) {
    const key = lang_key(lang);
    return PREVIEW_CONTACT_BY_LANG[key] || PREVIEW_CONTACT_BY_LANG.fr;
}

function lang_key(lang) {
    const key = (lang || 'fr').substring(0, 2);
    return COPY[key] ? key : 'fr';
}

function format(template, ...args) {
    let i = 0;
    return template.replace(/%s/g, () => args[i++] ?? '');
}

function esc_html(value) {
    return String(value ?? '').replace(/[&<>]/g, c => ({
        '&': '&amp;', '<': '&lt;', '>': '&gt;',
    }[c]));
}

function build_booking_row(t, screening_at, film_title, place_label, seat) {
    return `
<tr>
  <td style="padding: 10px 0 0 0; border-top: 1px dashed #aaaaaa;">
    <table cellspacing="0" cellpadding="0" border="0" width="100%">
      <tr>
        <td valign="top">
          <table cellpadding="0" cellspacing="0" border="0" width="25%" align="left">
            <tr><td style="font-family: Arial, sans-serif; color: #333333; font-size: 14px;">${esc_html(screening_at)}</td></tr>
          </table>
          <table cellpadding="0" cellspacing="0" border="0" width="40%" align="left">
            <tr><td align="center" style="font-family: Arial, sans-serif; color: #333333; font-size: 16px;">${esc_html(film_title)}</td></tr>
          </table>
          <table cellpadding="0" cellspacing="0" border="0" width="30%" align="right">
            <tr><td align="center" style="font-family: Arial, sans-serif; color: #333333; font-size: 14px;">${esc_html(place_label)} - <strong>${esc_html(seat)}</strong></td></tr>
          </table>
        </td>
      </tr>
    </table>
  </td>
</tr>`;
}

function build_change_row(t, changed_at, description) {
    return `
<tr>
  <td style="padding: 10px 0 0 0; border-top: 1px dashed #aaaaaa;">
    <table cellspacing="0" cellpadding="0" border="0" width="100%">
      <tr>
        <td valign="top">
          <table cellpadding="0" cellspacing="0" border="0" width="20%" align="left">
            <tr><td style="font-family: Arial, sans-serif; color: #333333; font-size: 12px;">${esc_html(changed_at)}</td></tr>
          </table>
          <table cellpadding="0" cellspacing="0" border="0" width="75%" align="right">
            <tr><td align="center" style="font-family: Arial, sans-serif; color: #333333; font-size: 12px;">${esc_html(description)}</td></tr>
          </table>
        </td>
      </tr>
    </table>
  </td>
</tr>`;
}

function build_bookings_table(t, booking_rows) {
    return `
<table border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width: 550px;">
  <tr>
    <td style="padding: 10px 0 0 0; border-top: 1px dashed #aaaaaa;">
      <table cellspacing="0" cellpadding="0" border="0" width="100%">
        <tr>
          <td valign="top">
            <table cellpadding="0" cellspacing="0" border="0" width="25%" align="left">
              <tr><th align="left" style="font-family: Arial, sans-serif; color: #333333; font-size: 16px;">${t.date_col}</th></tr>
            </table>
            <table cellpadding="0" cellspacing="0" border="0" width="40%" align="left">
              <tr><th align="center" style="font-family: Arial, sans-serif; color: #333333; font-size: 16px;">${t.booking_col}</th></tr>
            </table>
            <table cellpadding="0" cellspacing="0" border="0" width="30%" align="right">
              <tr><th align="center" style="font-family: Arial, sans-serif; color: #333333; font-size: 16px;">${t.place_col}</th></tr>
            </table>
          </td>
        </tr>
      </table>
    </td>
  </tr>
  ${booking_rows}
</table>`;
}

function build_changes_table(t, change_rows) {
    return `
<table border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width: 550px;">
  <tr>
    <td style="padding: 10px 0 0 0; border-top: 1px dashed #aaaaaa;">
      <table cellspacing="0" cellpadding="0" border="0" width="100%">
        <tr>
          <td valign="top">
            <table cellpadding="0" cellspacing="0" border="0" width="20%" align="left">
              <tr><th align="left" style="font-family: Arial, sans-serif; color: #333333; font-size: 12px;">${t.date_col}</th></tr>
            </table>
            <table cellpadding="0" cellspacing="0" border="0" width="75%" align="right">
              <tr><th align="center" style="font-family: Arial, sans-serif; color: #333333; font-size: 12px;">${t.description_col}</th></tr>
            </table>
          </td>
        </tr>
      </table>
    </td>
  </tr>
  ${change_rows}
</table>`;
}

/**
 * Sample booking summary HTML (aligned with eshop Email::build_parts_from_ticket).
 *
 * @param {{ lang?: string, setting?: Object, tickettype?: Object, contact?: Object }} params
 * @returns {{ content: string, subject: string, heading: string, opening: string }}
 */
export function build_preview_booking_summary({ lang, setting, tickettype, contact }) {
    const key = lang_key(lang);
    const t = COPY[key];
    const sample = contact || get_preview_sample_contact(lang);
    const buyer_name = `${sample.firstname || ''} ${sample.lastname || ''}`.trim();

    const screening_at = moment().add(3, 'days').locale(key).format(key === 'en' ? 'MM/DD/YYYY HH:mm' : 'DD.MM.YYYY HH:mm');
    const changed_at = moment().locale(key).format(key === 'en' ? 'MM/DD/YYYY HH:mm' : 'DD.MM.YYYY HH:mm');
    const film_title = PREVIEW_FILM_TITLES[key];
    const place_label = PREVIEW_PLACES[key];

    const booking_row = build_booking_row(t, screening_at, film_title, place_label, t.sample_seat);
    const change_row = build_change_row(t, changed_at, format(t.change_booked, film_title));

    let content = `<h2>${t.next_bookings}</h2>`;
    content += build_bookings_table(t, booking_row);
    content += '<br>';
    content += `<h3>${t.changes_title}</h3>`;
    content += build_changes_table(t, change_row);
    content += `<p><strong>${format(t.disclaimer, '<a href="#">', '</a>')}</strong></p>`;
    content += `<p><em>${format(t.qr_hint, '<a href="#">', '</a>')}</em></p>`;

    const type_name = tickettype
        ? (Utils.localized_or_fallback(tickettype.name, key) || tickettype._id)
        : (key === 'fr' ? 'Abonnement' : key === 'de' ? 'Abonnement' : 'Season pass');

    const customer_short = Utils.localized_or_fallback(setting?.customer?.name_short, key, '')
        || Utils.localized_or_fallback(setting?.customer?.name, key, '');

    const subject = `${customer_short} | ${type_name}`;
    const heading = t.heading;
    const opening = buyer_name ? format(t.opening_named, buyer_name) : '';

    return { content, subject, heading, opening };
}

/**
 * Context blocks for [booking.summary] in preview and test e-mail send.
 *
 * @param {Object} params
 * @returns {{ booking: { summary: string }, booking_summary: { content: string, subject: string, heading: string, opening: string } }}
 */
export function build_preview_booking_summary_context(params) {
    const parts = build_preview_booking_summary(params);
    return {
        booking: { summary: parts.content },
        booking_summary: parts,
    };
}

/**
 * Detect whether an e-mail layout is the booking summary template.
 *
 * @param {Object} layout
 * @param {Object} setting
 * @returns {boolean}
 */
export function is_booking_summary_email_layout(layout, setting) {
    if (!layout || layout.layout_type !== 'email')
        return false;

    if (layout.type)
        return layout.type === EMAIL_LAYOUT_TYPE_BOOKING;

    if (setting?.email_layouts?.booking_summary &&
        String(setting.email_layouts.booking_summary) === String(layout._id))
        return true;

    return Utils.langs().some(lang => {
        const text = (layout.widgets || [])
            .filter(w => w.type === 'text')
            .map(w => w.options?.text?.[lang] || '')
            .join(' ');
        return text.includes('[booking.summary]');
    });
}
